import { withPagination } from 'shared/table/hoc/withPagination';
import {
  TransactionTable,
  TransactionTableProps,
} from '../TransactionTable/TransactionTable';
import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { useCoreService } from 'core/services/useCoreService';
import { useDataFetcher } from 'shared/http';
import { Pageable } from 'shared/table/models/Pageable';
import { useEffect, useMemo } from 'react';
import { SearchMovimientosRequest } from 'core/movimientos/models/SearchMovimientosRequest';

const TableWithPagination = withPagination<Movimiento, TransactionTableProps>(
  TransactionTable,
);

const DEFAULT_NO_RESULT_MESSAGE =
  'No se encontraron movimientos que concuerden con los parámetros de la búsqueda';

export const TransactionTableWithPagination = (props: {
  searchParams: SearchMovimientosRequest;
  reloadToken?: number;
  noResultsMessage?: string;
}) => {
  const coreService = useCoreService();
  const [centroCostos, fetchCentroCostos] = useDataFetcher<Pageable<Movimiento>>();

  const filtrosEstables = useMemo(() => {
    return props.searchParams;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(props.searchParams)]);

  useEffect(() => {
    fetchCentroCostos(() => coreService.findMovimientos(filtrosEstables));
  }, [coreService, fetchCentroCostos, filtrosEstables, props.reloadToken]);

  const onChangePaginationStatus = async (status: {
    pageNumber: number;
    pageSize: number;
  }): Promise<Pageable<Movimiento>> => {
    props.searchParams.page = status.pageNumber;
    props.searchParams.size = status.pageSize;
    return coreService.findMovimientos(props.searchParams);
  };

  return (
    <TableWithPagination
      pageableInit={centroCostos.data}
      loadingState={centroCostos.isLoading}
      dataFetcherFunction={onChangePaginationStatus}
      noResultsMessages={props.noResultsMessage || DEFAULT_NO_RESULT_MESSAGE}
    ></TableWithPagination>
  );
};
